// data/languages/peul/categories/temps.ts
import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
  // JOURS DE LA SEMAINE - Emprunts arabes standardisés
  'Aabnde': { translation: 'Lundi', translationEn: 'Monday', audio: 'Ff-Aabnde', illustration: '1️⃣' },
  'Mawbaare': { translation: 'Mardi', translationEn: 'Tuesday', audio: 'Ff-Mawbaare', illustration: '2️⃣' },
  'Njeslaare': { translation: 'Mercredi', translationEn: 'Wednesday', audio: 'Ff-Njeslaare', illustration: '3️⃣' },
  'Nasaande': { translation: 'Jeudi', translationEn: 'Thursday', audio: 'Ff-Nasaande', illustration: '4️⃣' },
  'Mawnde': { translation: 'Vendredi', translationEn: 'Friday', audio: 'Ff-Mawnde', illustration: '5️⃣' },
  'Hoore biir': { translation: 'Samedi', translationEn: 'Saturday', audio: 'Ff-Hoore_biir', illustration: '6️⃣' },
  'Dewo': { translation: 'Dimanche', translationEn: 'Sunday', audio: 'Ff-Dewo', illustration: '7️⃣' },

  // PARTIES DE LA JOURNÉE - Terminologie peule authentique

   'Kammu': { translation: 'Ciel', translationEn: 'Sky', audio: 'Ff-Kammu', illustration: '' },
  'Nguleendi': { translation: 'Chaleur', translationEn: 'Heat', audio: 'Ff-Nguleendi', illustration: '' },

  // RÉFÉRENCE TEMPORELLE - Jours relatifs
  'Hannde': { translation: 'Aujourd\'hui', translationEn: 'Today', illustration: '📍' },
  'Haŋki': { translation: 'Hier', translationEn: 'Yesterday', illustration: '⬅️' },
  'Janngo': { translation: 'Demain', translationEn: 'Tomorrow', illustration: '➡️' },
  'Ɲiiri hannde': { translation: 'Avant-hier', translationEn: 'The day before yesterday', illustration: '⬅️⬅️' },
  'Yeeso janngo': { translation: 'Après-demain', translationEn: 'The day after tomorrow', illustration: '➡️➡️' },

  // UNITÉS DE TEMPS - Vocabulaire fondamental
  'Ɲalawma': { translation: 'Jour (24h)', translationEn: 'Day (24h)', illustration: '📆' }, // Corrigé orthographe
  'Yontere': { translation: 'Semaine', translationEn: 'Week', illustration: '📅' },
  'Lewru': { translation: 'Mois', translationEn: 'Month', illustration: '🗓️' },
  'Duuɓi': { translation: 'Année', translationEn: 'Year', illustration: '📊' }, // Corrigé de Hitaande
  'Duuɓi gooto': { translation: 'Une année', translationEn: 'One year', illustration: '1️⃣📊' },

  // SAISONS - Importantes dans la culture pastorale peule
  'Ceeɗu': { translation: 'Saison sèche froide', translationEn: 'Cold dry season', illustration: '🏜️❄️' },
  'Ɓeelo': { translation: 'Saison sèche chaude', translationEn: 'Hot dry season', illustration: '🏜️🔥' },
  'Ndungu': { translation: 'Saison des pluies', translationEn: 'Rainy season', illustration: '🌧️' },

  // EXPRESSIONS TEMPORELLES COURANTES
  'Jooni': { translation: 'Maintenant', translationEn: 'Now', illustration: '⏰' },
  'Ɗuum': { translation: 'Ce moment-là', translationEn: 'That moment', illustration: '⏳' },
  'Teeminere': { translation: 'Longtemps', translationEn: 'A long time', illustration: '⌛' },
  'Saɓɓu': { translation: 'Tôt', translationEn: 'Early', illustration: '⏰' },
  'Sakito': { translation: 'Tard', translationEn: 'Late', illustration: '⏰' },

  // MOMENTS RELIGIEUX/CULTURELS
  'Subbaaka ṣalaa': { translation: 'Prière du matin', translationEn: 'Morning prayer', illustration: '🕌🌅' },
  'Luhar': { translation: 'Prière de midi', translationEn: 'Noon prayer', illustration: '🕌☀️' },
  'Magrib': { translation: 'Prière du coucher', translationEn: 'Sunset prayer', illustration: '🕌🌆' }
};

export default temps;
